import api from 'api/setupAxios';
import {
  DOCUMENT_BY_ID,
  DOCUMENT_UPLOAD,
  DOCUMENT,
  DOCUMENT_SUBMIT,
  DOCUMENT_UNSUBMIT
} from 'const/endpoint';
import type {
  DocumentAccountResponse,
  DocumentId,
  DocumentUploadId
} from 'types/Document';

export const uploadMerchantDocument = async (
  type: DocumentUploadId,
  fd: FormData,
  signal?: AbortSignal
) => {
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  const res = await api
    .call(signal)
    .post(DOCUMENT_UPLOAD.replace(':type', type), fd, config);

  return res.data;
};

export const getMerchantDocument = async (
  type: DocumentId['screen'],
  params: { page: number; itemsPerPage: number },
  signal?: AbortSignal
): Promise<DocumentAccountResponse> => {
  const res = await api
    .call(signal)
    .get(
      `${DOCUMENT}?type=${type}&page=${params.page}&itemsPerPage=${params.itemsPerPage}`
    );

  return res.data;
};

export const deleteMerchantDocument = async (id: number) => {
  const res = await api
    .call()
    .delete(DOCUMENT_BY_ID.replace(':id', String(id)));

  return res.data;
};

export const submitMerchantDocument = async (type: DocumentId['screen']) => {
  const res = await api.call().post(DOCUMENT_SUBMIT.replace(':type', type));

  return res.data;
};

export const unSubmitMerchantDocument = async (type: DocumentId['screen']) => {
  const res = await api.call().post(DOCUMENT_UNSUBMIT.replace(':type', type));

  return res.data;
};
